import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiGetTreatmentCategories } from 'services/TreatementsService'

/**
 * Slice globale : liste des catégories de traitement (actives et inactives).
 * Chargée une fois après connexion (voir components/layout/index.js) et
 * rafraîchie après chaque création / modification / désactivation.
 */
export const getTreatmentCategories = createAsyncThunk(
    'treatmentCategories/getTreatmentCategories',
    async (params = {}) => {
        const response = await apiGetTreatmentCategories({
            includeInactive: true,
            ...params,
        })
        return response.data
    }
)

export const initialState = {
    list: [],
    loading: false,
    loaded: false,
    error: null,
}

export const treatmentCategoriesSlice = createSlice({
    name: 'treatmentCategories',
    initialState,
    reducers: {
        resetTreatmentCategories: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTreatmentCategories.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(getTreatmentCategories.fulfilled, (state, action) => {
                state.list = Array.isArray(action.payload?.data)
                    ? action.payload.data
                    : []
                state.loading = false
                state.loaded = true
            })
            .addCase(getTreatmentCategories.rejected, (state, action) => {
                state.loading = false
                state.error = action.error?.message || 'error'
            })
    },
})

export const { resetTreatmentCategories } = treatmentCategoriesSlice.actions

export default treatmentCategoriesSlice.reducer
